import { parseIntegerInput } from "@/lib/parse-number";

/** An optional sign, then 1-3 digits (no leading zero) and groups of exactly 3, one separator kind. */
const COMMA_GROUPED = /^([+-]?)([1-9]\d{0,2}(?:,\d{3})+)$/;
const DOT_GROUPED = /^([+-]?)([1-9]\d{0,2}(?:\.\d{3})+)$/;
const SPACES = /[\s  ]/g;
const SEPARATORS = /[.,]/g;

/**
 * A typed whole number, where a lone `,` or `.` followed by exactly three digits is a
 * thousands separator.
 *
 * `parseIntegerInput` follows the site's general rule that a lone separator is a decimal
 * mark, so "1,000" is 1.000 and passes as 1 — a silent wrong answer in a field that
 * accepts only whole numbers and whose own message offers "1,000" as valid. In a
 * whole-number field the decimal reading can only be a number with a meaningless
 * fraction, so the grouped reading wins: "1,000" and "1.000" are 1000, "12,345" is
 * 12345. Everything else defers to `parseIntegerInput`, so "2,5", "0,375" and "1.5"
 * stay rejected as not whole.
 */
export function parseWholeNumberInput(raw: string): number | null {
  const compact = raw.replace(SPACES, "");
  const match = COMMA_GROUPED.exec(compact) ?? DOT_GROUPED.exec(compact);
  if (match === null) {
    return parseIntegerInput(raw);
  }
  const value = Number(`${match[1]}${match[2].replace(SEPARATORS, "")}`);
  return Number.isFinite(value) ? value : null;
}
